// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"285":"f7361a56","973":"f7361a56"}[chunkId] + ".chunk.css";
};